// src/components/CheckboxCardFrame.tsx
import * as React from 'react'
import {
  Button,
  CheckboxCard,
  CheckboxGroup,
  Flex,
  Text,
  // type CheckboxCardProps,
} from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'

export type CheckboxCardOption = {
  id: string // value used by the group
  label: string // main title
  description?: string // sub text under title
  isDisabled?: boolean
}

type Props = {
  options: CheckboxCardOption[]
  value: string[]
  onChange: (next: string[], meta: { id: string; checked: boolean }) => void
}

export default function CheckboxCardFrame({ options, value, onChange }: Props) {
  const prevRef = React.useRef<string[]>(value)

  React.useEffect(() => {
    prevRef.current = value
  }, [value])

  const handleValueChange = (next: string[]) => {
    const prev = prevRef.current ?? []

    const added = next.find(v => !prev.includes(v))
    const removed = prev.find(v => !next.includes(v))
    const id = added ?? removed ?? ''
    const checked = Boolean(added)

    onChange(next, { id, checked })
    prevRef.current = next
  }

  const toggle = (id: string) => {
    const wasChecked = value.includes(id)
    const next = wasChecked ? value.filter(v => v !== id) : [...value, id]
    console.log('wasChecked', wasChecked)
    console.log('next', next)
    onChange(next, { id, checked: !wasChecked })
  }

  return (
    <CheckboxGroup value={value} onValueChange={handleValueChange}>
      {/* <> */}
      <Flex align="center" mb="2" gap="3">
        <Text textStyle="smNormal">Nach Leistungsempfänger filtern</Text>

        <Button
          variant="subtle"
          colorPalette="gray"
          onClick={() => onChange([], { id: '__clear__', checked: false })}
          disabled={(value?.length ?? 0) === 0}
        >
          <LuX></LuX>
          Auswahl aufheben
        </Button>
      </Flex>

      <Flex mt={1} gap="2" wrap="wrap">
        {options.map(opt => {
          return (
            <CheckboxCard.Root
              maxW="229px"
              key={opt.id}
              value={opt.id}
              onClick={e => {
                e.preventDefault()
                toggle(opt.id)
              }}
              pointerEvents={opt.isDisabled ? 'none' : 'auto'}
              cursor={opt.isDisabled ? 'not-allowed' : 'pointer'}
              flexBasis={{ base: 'calc(50% - 8px)', md: 'calc(25% - 8px)' }}
            >
              <CheckboxCard.HiddenInput />
              <CheckboxCard.Control>
                <CheckboxCard.Content>
                  <CheckboxCard.Label>{opt.label}</CheckboxCard.Label>
                  <CheckboxCard.Description>{opt.description}</CheckboxCard.Description>
                </CheckboxCard.Content>
                <CheckboxCard.Indicator />
              </CheckboxCard.Control>
            </CheckboxCard.Root>
          )
        })}
      </Flex>
    </CheckboxGroup>
  )
}
